module.exports = new __parcel__URL__("tabs_ja.7e7d9877.webp").toString();